(function () {
    'use strict';

    angular.module('Directives').directive('bbaCustomsManifestSettings', bbaCustomsManifestSettings);

    bbaCustomsManifestSettings.$inject = [];

    function bbaCustomsManifestSettings() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-customs-manifest-settings.html',
            scope: {
                customsSettings: '=',
            },
            controller: bbaCustomsManifestSettingsController,
            controllerAs: 'vm',
            bindToController: true
        }

        function bbaCustomsManifestSettingsController($scope) {
            const vm = this;
            init();

            function init() {
                getParamsData();
            }

            function getParamsData() {
                $scope.$watch('vm.customsSettings', (data) => {
                    if (!data) return;
                    
                    data.sort((a, b) => a.type.localeCompare(b.name));
                    vm.customsSettings.paramData = {};
                    
                    data.forEach(d => {
                        if (d.type === 'Boolean') {
                            vm.customsSettings.paramData[d.name] = d.value === 'true' ? true : false;
                        } else {
                            vm.customsSettings.paramData[d.name] = d.value;
                        }
                    });
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaCustomsManifestSettings.js